import React, { Component, Fragment } from 'react';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button, ButtonGroup, Alert } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { aggregate, sort_by, CustomListSelect, reordered_array_keys } from './Functions';
import { RenderTable, RenderVirtualTable } from './TableComponent';
import { PiePlot, MultBarPlot, BarPlot, MultLineTsPlot, ScatterPlot } from './PlotComponent';
import HeatMap from 'react-heatmap-grid';
import { postRequest } from '../redux/ActionCreators';

// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    client_portfolio: state.client_portfolio,
    client_port_metrics: state.client_port_metrics,
    client_params: state.client_params,
  };
};

class ClientPortMetrics extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_metrics:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        ret_period:'YTD'
      };
      this.loadMetrics = this.loadMetrics.bind(this);
      this.header = this.header.bind(this);
  }
  
  async loadMetrics(){
    if (this.props.client_params.port_name=='' || this.props.client_params.port_name==null) {
      this.setState({msg:"Seleccionar portafolio!"});
    } else if (this.props.client_portfolio==null){
      this.setState({
        msg:"Cargar portafolio del cliente!"
      });
    } else {
      this.setState({msg:null});
      this.setState({loading_metrics:true});
      try {
        const client_port_metrics = await postRequest(
          { 
            port:this.props.client_params.risk_type=="ex_ante" ? this.props.client_portfolio.port.map(item=>{
              const entry = {name:item.assetName, value:item.mktValue};
              if (item.benchmark !== undefined) {
                entry.benchmark = item.benchmark;
              }
                return entry;
              }) : null,
            bench:null,
            client_id:this.props.client_params.risk_type=="ex_ante" ? null : this.props.client_params.port_name, 
            client_cty:this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].cty,
            ref_curr:this.props.client_params.fx,
            ini_date:this.props.client_params.metrics_date,
            use_assets_bench:this.props.client_params.assets_bench
          }, 'port_metrics_wm');
        await this.props.changeModel('client_port_metrics', {...client_port_metrics, risk_type:this.props.client_params.risk_type});
        this.setState({loading_metrics:false});
      } catch (error) {
        console.error('Error getting response:', error);
        await this.props.changeModel('client_port_metrics', null);
        this.setState({
          loading_metrics:false,
          msg: error.message
        });
      }
    }
  }

  header(){
    return(
      <>
        <div className="row mt-5 justify-content-center">
          <div className="col-auto">
            <h4>Análisis de Portafolio</h4>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className="col-auto">
            <Breadcrumb>
              <BreadcrumbItem><Link to='/client_portfolio/stage/check'>Chequeo del Portafolio</Link></BreadcrumbItem>
              <BreadcrumbItem active>Evaluación de Riesgo</BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/suitability'>Alineación de Estrategia de Inversión</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/adjust'>Ajuste de Portafolio</Link></BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className='col-md-2'>
            <Input 
              type="date" 
              value={this.props.client_params.metrics_date} onChange={(e)=>this.props.changeModel('client_params.metrics_date',e.target.value)}
              placeholder="Fecha..."
            >
            </Input>
          </div>
          <div className='col-md-2'>
            <CustomListSelect
              options={['USD', 'MXN', 'COP', 'PEN', 'CLP', 'UYU'].map(x=>{
                return {value:x, label:x};
              })}
              isClearable={true}
              value={{value:this.props.client_params.fx, label:this.props.client_params.fx}}
              onChange={(e)=>this.props.changeModel("client_params.fx", e==null ? null : e.value)}
              itemSize={50}
              className="basic-single"
              isDisabled={this.props.client_params.risk_type=='ex_post'}
              placeholder="seleccionar fx"
            />
          </div>
          <div className='col-2'>
            <Label check>
              <Input type="checkbox"
                checked={this.props.client_params.assets_bench}
                onChange={()=>this.props.changeModel("client_params.assets_bench", !this.props.client_params.assets_bench)}
                />{' '}
                <small>usar benchmarks</small>
            </Label>
          </div>
          
        </div>

        <div className="row m-4 justify-content-center">
          <div className='col-3'>
            <ButtonGroup size='sm'>
              <Button
                color="dark"
                outline
                onClick={() => this.props.changeModel("client_params.risk_type", 'ex_ante')}
                active={this.props.client_params.risk_type=='ex_ante'}
              >
                Riesgo Actual
              </Button>
              <Button
                color="dark"
                outline
                onClick={() => this.props.changeModel("client_params.risk_type", 'ex_post')}
                active={this.props.client_params.risk_type=='ex_post'}
              >
                Riesgo realizado
              </Button>
            </ButtonGroup>
          </div>
          <div className='col-md-2'>
            <Button 
              className="btn-corp"
              onClick={this.loadMetrics}
            >
              Actualizar Métricas
            </Button>
          </div>
          <div className="row mt-4 justify-content-center">
            <div className="col-6 m-3">
              <Alert
                color={this.state.msg!==null && this.state.msg.includes('Error') ? 'danger':'secondary'}
                isOpen={this.state.msg!=='' && this.state.msg!==null} 
                toggle={()=>this.setState({msg:null})}
                fade={false}
                >
                  {this.state.msg}
              </Alert>
            </div>
          </div>
        </div>
      </>
      );
  }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else if (this.state.loading_metrics){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center">
                <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
              </div>
            </div>
          );
      } else if (this.props.client_port_metrics==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                  <h6>No hay datos disponibles.</h6>
              </div>
            </div>
          );
      } else {
        const real_rets = this.props.client_port_metrics==null ? null
                          : this.props.client_port_metrics.real_rets.map(({Periodo, Portafolio}) => ({Periodo, Portafolio}));
        const real_rets_assets = this.props.client_port_metrics==null ? null
                          : reordered_array_keys(this.props.client_port_metrics.real_rets_assets, 'Periodo');
        
        const rets_summ = this.props.client_port_metrics==null ? null
                          : this.props.client_port_metrics.rets_summ.map(({Métrica, Portafolio}) => ({Métrica, Portafolio}));

        const assets_summ = this.props.client_port_metrics==null ? null
                          : Object.keys(this.props.client_port_metrics.rets_summ[0]).filter(x=>x!=='Métrica').map(z=>{
                            return {
                              'Activo':z,
                              'Retorno Promedio':this.props.client_port_metrics.rets_summ.filter(x=>x['Métrica']=='Retorno Promedio Anual.')[0][z],
                              'Volatilidad':this.props.client_port_metrics.rets_summ.filter(x=>x['Métrica']=='Volatilidad Anual.')[0][z]
                              };
                          });
        const series = this.props.client_port_metrics==null ? null : this.props.client_port_metrics.series.map(({Date, Portafolio}) => ({Date, Portafolio}));

        return (
          <div className="container">
            {this.header()}
            {/*Retornos*/}
            <div className="row m-5 justify-content-center">
              <div className='col' id="real_rets">
                <h5><b>Retornos Realizados ({this.props.client_port_metrics.risk_type})</b></h5>
                <a className='linkcol' href='#risk'>riesgo-retorno&darr;</a>
                <a className='linkcol' href='#assets'>{"        "}activos&darr;</a>
              </div>
            </div>
            {real_rets!=null 
            ? <div className="row m-5 justify-content-center align-items-start">
                <div className='col-md-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={real_rets} 
                        to_perc={[false, true, true]}
                        cell_width={["150px", '150px']}
                        item_size={30}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  {this.props.client_port_metrics.names.length>1
                  ? <MultBarPlot 
                      data={real_rets}
                      nameKey='Periodo'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#2803fc"]}
                      xpercAxis={true}
                      percTooltip={false}
                      width={500}
                      ml={50}
                      top={0}
                      interval={0}
                      height={400}
                      barsize={10}
                    />
                  : <BarPlot 
                      y={real_rets.map(x=>x.Periodo)}
                      x={real_rets.map(x=>x.Portafolio)}
                      layout="vertical"
                      angle={0}
                      ytype="category" xtype="number"
                      color="#000000"
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      ml={50}
                      top={0}
                      interval={0}
                      height={400}
                      barsize={10}
                    />
                  }
                </div>
              </div>
            : <></>
            }
            {series!=null 
            ? <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-4 justify-content-center">
                <div className='col' id="risk">
                  <h5>Riesgo - Retorno ({this.props.client_port_metrics.risk_type})</h5>
                  <a className='linkcol' href='#real_rets'>retornos realizados&uarr;</a>
                  <a className='linkcol' href='#assets'>{"        "}activos&darr;</a>
                </div>
              </div>
              <div className="row m-5 justify-content-center align-items-start">
                <div className='col-md-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={rets_summ}
                        to_perc={[false, true]} 
                        to_perc_row={[true, true, true, true, false, true, false, false, false, false]}
                        cell_width={["200px", '150px']}
                        item_size={30}
                        fontsize={12}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultLineTsPlot data={series}
                     width={500}
                     xkey='Date'
                     ykeys={this.props.client_port_metrics.names}
                     xtype='category'
                     ytype='number'
                     top={5}
                     colors = {['#000000']}
                     percTooltip={false}
                     legend={false}
                     ml={50}
                  />
                </div>
              </div>
              {/*
              <div className="row m-4 justify-content-center align-items-center">
                {this.props.client_port_metrics.neg_rets_perc!==null ?
                <div className='col-md-6'>
                  <div className="row m-2 justify-content-center align-items-center">
                    <div className='col'>
                      <h6><b>Probabilidad de Retornos Negativos</b></h6>
                    </div>
                  </div>
                  <div className="row m-2 justify-content-center align-items-center">
                    <div className='col'>
                      <BarPlot 
                        y={this.props.client_port_metrics.neg_rets_perc.map(x=>x.Portafolio)}
                        x={this.props.client_port_metrics.neg_rets_perc.map(x=>x.period)}
                        layout="horizontal"
                        angle={0}
                        ytype="number" xtype="category"
                        color="#000000"
                        ypercAxis={true}
                        percTooltip={true}
                        width={500}
                        ml={150}
                        interval={0}
                        height={300}
                        barsize={10}
                      />
                    </div>
                  </div>
                </div>
                :null
                }
                <div className='col-md-6'>
                  <div className="row m-2 justify-content-center align-items-center">
                    <div className='col'>
                      <h6><b>Retorno Total ({this.props.client_port_metrics.risk_type})</b></h6>
                    </div>
                  </div>
                  <div className="row m-2 justify-content-center align-items-center">
                    <div className='col'>
                      <HeatMap 
                        xLabels={this.props.client_port_metrics.total_rets.labels} 
                        yLabels={this.props.client_port_metrics.total_rets.labels} 
                        data={this.props.client_port_metrics.total_rets.port} 
                        cellRender={(value) => <strong>{value}%</strong>}
                        cellStyle={(background, value, min, max, data, x, y) => ({
                          background: `rgba(66, 86, 244, ${1 - (max - value) / (max - min)})`,
                          fontSize: "10px",
                          color:"black"
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
              */}
              {assets_summ.filter(item=>item.Activo!=='Portafolio').length>0 ?
              <>
                <div className="row justify-content-center align-items-center">
                  <div className='col p-5'>
                    <hr />
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6' id="assets">
                    <h5><b>Activos</b></h5>
                    <a className='linkcol' href='#real_rets'>retornos realizados &uarr;</a>
                    <a className='linkcol' href='#risk'>riesgo-retorno &uarr;</a>
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <h6><b>Retornos Realizados</b></h6>
                  </div>
                </div>
                {Object.keys(real_rets_assets[0]).length>10 ?
                <div className="row m-4 justify-content-center align-items-center">
                  <div className="col-auto">
                    <RenderVirtualTable 
                      data={real_rets_assets} 
                      to_perc={[false, true, true]} 
                      cell_width={new Array(Object.keys(real_rets_assets[0]).length).fill('70px')}
                      item_size={40}
                      fontsize={12}
                      style="black"
                      />
                  </div>
                </div>
                :
                <>
                  <div className="row justify-content-center">
                    <div className='col-1'>
                      <Input bsSize='sm' type="select" value={this.state.ret_period} 
                        onChange={(e)=>this.setState({ret_period:e.target.value})}
                      >
                        {real_rets_assets.map(k=>k.Periodo).map((x,i)=>{
                          return (<option key={i}>{x}</option>);
                        })}
                      </Input>
                    </div>
                  </div>
                  <div className="row m-4 justify-content-center align-items-start">
                    <div className='col-6'>
                      <div className="row justify-content-center">
                        <div className="col-auto">
                          <RenderVirtualTable 
                            data={real_rets_assets} 
                            to_perc={[false, true, true]} 
                            cell_width={Object.keys(real_rets_assets[0]).length>4 ? new Array(Object.keys(real_rets_assets[0]).length).fill('70px') : new Array(Object.keys(real_rets_assets[0]).length).fill('120px')}
                            item_size={40}
                            fontsize={12}
                            style="black"
                            />
                        </div>
                      </div>
                    </div>
                    <div className='col-6'>
                      <MultBarPlot 
                        data={Object.keys(real_rets_assets[0]).filter(k=>k!=='Periodo').map(x=>{
                          return {asset:x, Retorno:real_rets_assets.filter(item=>item.Periodo==this.state.ret_period)[0][x]}
                        })}
                        nameKey='asset'
                        vertical={true}
                        angle={0}
                        ytype="category" xtype="number"
                        colors={["#000000", "#2803fc"]}
                        xpercAxis={true}
                        percTooltip={true}
                        moneyTooltip={false}
                        width={500}
                        ml={150}
                        interval={0}
                        height={400}
                        barsize={10}
                      />
                    </div>
                  </div>
                </>
                }

                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <h6>Riesgo - Retorno</h6>
                  </div>
                </div>
                <div className="row m-5 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <div className="row justify-content-center">
                      <div className='col-auto'>
                        <RenderVirtualTable 
                          data={assets_summ.filter(item=>item.Activo!=='Portafolio').sort(sort_by('Volatilidad'))} 
                          to_perc={[false, true, true]} 
                          cell_width={['200px', "100px", '100px']}
                          item_size={40}
                          fontsize={12}
                          style="black"
                          />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <ScatterPlot
                      data={assets_summ.filter(x=>x.Activo!=='Portafolio')}
                      color="#000000"
                      data2={assets_summ.filter(x=>x.Activo=='Portafolio')}
                      color2="#0303fc"
                      xlabel="Volatilidad"
                      ylabel="Retorno Promedio"
                      xAxisId="Volatilidad"
                      yAxisId="Retorno Promedio"
                      zAxisId='Activo'
                      dataName='Activos'
                      dataName2='Portafolio'
                      width={500}
                    />
                  </div>
                </div>
              </>
              :null
              }
              </>
            : <></>
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(ClientPortMetrics));